import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import querystring from 'querystring';
import { fetchClasses } from './actions';
import ClassPage from './ClassPage';
import GolfSchoolPage from './GolfSchoolPage';
import Loading from '../common/components/Loading';
import { selectActiveGolfSchool } from './selectors';

class GolfSchool extends Component {
  componentDidMount = () => {
    const { activeGolfSchool, dispatch, location: { search } } = this.props;
    const qs = search ? querystring.parse(search.slice(1)) : {};

    dispatch(fetchClasses(activeGolfSchool.id, qs));
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.location.search !== this.props.location.search ||
      (this.props.match.isExact && !prevProps.match.isExact)
    ) {
      const { search } = this.props.location;
      const qs = search ? querystring.parse(search.slice(1)) : {};

      this.props.dispatch(fetchClasses(this.props.activeGolfSchool.id, qs));
    }
  }

  render() {
    const { match, loaded } = this.props;

    if (!loaded) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route exact path={`${match.path}/`} component={GolfSchoolPage} />
        <Route exact path={`${match.path}/classes/:classId`} component={ClassPage} />
        <Redirect to={`${match.path}`} />
      </Switch>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    activeGolfSchool: selectActiveGolfSchool(state, ownProps.match.params.schoolId),
    loaded: state.golfSchools.classes.get('loaded'),
  };
};

export default connect(mapStateToProps)(GolfSchool);



// WEBPACK FOOTER //
// ./src/golf-schools/GolfSchoolClasses.js